import TemplateCategoryContainer from "./TemplateCategoryContainer";
export default TemplateCategoryContainer;
